import Userprofile from "../../components/dashboard/profile";

function ProfilePage() {
  return (
    <>
      <Userprofile />
    </>
  );
}

export default ProfilePage;
